import { observer } from "mobx-react";
import { Box } from "@mui/material";
import ContentBlock from "../components/ContentBlock";
import MyNotesForm from "../components/forms/mynotes/MyNotesForm";
import { useEffect, useState } from "react";
import MyNotesDayList from "../components/lists/MyNotesDayList";
import { useStoreContext } from "..";
import InfoText from "../components/typographies/InfoText";
import { useTranslation } from "react-i18next";

const MyNotesPage = observer(() => {
  const { t } = useTranslation();
  const [selectedDay, setSelectedDay] = useState<any | undefined>(undefined);
  const { measurementStore } = useStoreContext();

  useEffect(() => {
    if (!measurementStore.notes) {
      measurementStore.getNotes();
    }
  }, [measurementStore.notes]);

  const handleSelectDay = (day: any) => {
    setSelectedDay(day);
  };
  return (
    <Box className="page-container">
      <Box sx={{ marginBottom: 2 }}>
        <InfoText text={t("mynotes.info")} />
      </Box>
      <ContentBlock title="Mina anteckningar" icon="edit" bottomMargin>
        <MyNotesForm
          selectedDay={selectedDay}
          onDeSelect={() => setSelectedDay(undefined)}
        />
      </ContentBlock>
      <ContentBlock title=" Mina anteckningar" icon="list">
        <MyNotesDayList onClick={handleSelectDay} />
      </ContentBlock>
    </Box>
  );
});

export default MyNotesPage;
